module.exports = __webpack_public_path__ + "img/icon-close.2b7789e9.svg";